import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SuggestionComponent } from './suggestion/suggestion.component';
import { TrendingComponent } from './trending/trending.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SearchComponent } from './search/search.component';
import { SkeletonModule } from 'primeng/skeleton';
import { CardModule } from 'primeng/card';
import { ShareModule } from "../share/share.module";
import { RippleModule } from 'primeng/ripple';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Ai_summaryComponent } from './ai_summary/ai_summary.component';
import { NlpModule } from '../nlp/nlp.module';
import { NewsModule } from '../news/news.module';


@NgModule({
    declarations: [
        HomeComponent,
        TrendingComponent,
        SuggestionComponent,
        SearchComponent,
        Ai_summaryComponent,
   
    ],
    imports: [
        CommonModule,
        HomeRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        SkeletonModule,
        CardModule,
        ShareModule,
        RippleModule,
        ProgressSpinnerModule,
        NlpModule,
        NewsModule
    ],
    exports: [
        TrendingComponent,
        SuggestionComponent,
        SearchComponent,
        CardModule,
        Ai_summaryComponent
    ]
})
export class HomeModule { }
